'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { useCommentContext } from '@/contexts/comment.context';
import { useCommentsContext } from '@/contexts/comments.context';
import { useCreatePostComment } from '@/hooks/queries/comment.query';

// Local interface to bypass external type pathing issues
interface LocalComment {
  id: string;
  [key: string]: any;
}
type CommentReplyProps = {
  comment: LocalComment;
  onSuccess?: () => void;
};
export function CommentReply(t0) {
  const $ = _c(41);
  const {
    comment,
    onSuccess
  } = t0;
  const [content, setContent] = useState("");
  const {
    slug
  } = useCommentsContext();
  const {
    setIsReplying
  } = useCommentContext();
  const t = useTranslations();
  let t1;
  if ($[0] !== slug) {
    t1 = {
      slug
    };
    $[0] = slug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mutate: createReply,
    isPending
  } = useCreatePostComment(t1);
  let t2;
  if ($[2] !== comment || $[3] !== content || $[4] !== createReply || $[5] !== onSuccess || $[6] !== setIsReplying || $[7] !== slug || $[8] !== t) {
    t2 = e => {
      e.preventDefault();
      if (!content.trim()) {
        toast.error(t("error.comment-content-required" as any));
        return;
      }
      createReply({
        slug,
        content: content.trim(),
        parentId: comment.id,
        date: new Date().toISOString()
      }, {
        onSuccess: () => {
          setContent("");
          setIsReplying(false);
          onSuccess?.();
          toast.success(t("success.reply-posted" as any));
        },
        onError: () => {
          toast.error(t("error.failed-to-post-reply" as any));
        }
      });
    };
    $[2] = comment;
    $[3] = content;
    $[4] = createReply;
    $[5] = onSuccess;
    $[6] = setIsReplying;
    $[7] = slug;
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleSubmit = t2;
  let t3;
  if ($[10] !== t) {
    t3 = t("blog.write-a-reply" as any);
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_0 => setContent(e_0.target.value);
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== content || $[14] !== isPending || $[15] !== t3) {
    t5 = <Textarea placeholder={t3} value={content} onChange={t4} className="min-h-24 resize-none" disabled={isPending} />;
    $[13] = content;
    $[14] = isPending;
    $[15] = t3;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== setIsReplying) {
    t6 = () => setIsReplying(false);
    $[17] = setIsReplying;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t) {
    t7 = t("common.cancel" as any);
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== isPending || $[22] !== t6 || $[23] !== t7) {
    t8 = <Button type="button" variant="ghost" size="sm" onClick={t6} disabled={isPending}>{t7}</Button>;
    $[21] = isPending;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== content || $[26] !== isPending) {
    t9 = isPending || !content.trim();
    $[25] = content;
    $[26] = isPending;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== isPending || $[29] !== t) {
    t10 = isPending ? "..." : t("blog.post-reply" as any);
    $[28] = isPending;
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t9) {
    t11 = <Button type="submit" size="sm" disabled={t9}>{t10}</Button>;
    $[31] = t10;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t8) {
    t12 = <div className="flex justify-end gap-3">{t8}{t11}</div>;
    $[34] = t11;
    $[35] = t8;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== handleSubmit || $[38] !== t12 || $[39] !== t5) {
    t13 = <form onSubmit={handleSubmit} className="mt-4 space-y-3">{t5}{t12}</form>;
    $[37] = handleSubmit;
    $[38] = t12;
    $[39] = t5;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  return t13;
}